window.addEventListener('DOMContentLoaded', () => {
	const js_buttons = document.querySelectorAll('.js-button__slide-filter');
	// add event to each slidemenu, toggling attribute open="" on and off
  for (let i = 0; i < js_buttons.length; i++) {
    if (js_buttons[i].getAttribute('listener') !== 'true') {
      js_buttons[i].addEventListener('click', () => {
        js_buttons[i].parentNode.toggleAttribute('open');
        js_buttons[i].setAttribute('listener', 'true');
      });
    }
  }

/*
	const filter = document.querySelector('facet-filters-form .js-form__filters');
  const product_grid_w = document.querySelector('#product-grid');
	const loadMore = document.querySelector('.load-more_wrap');
    if(window.location.search.includes('filter') === true && window.innerWidth >= 750) {
      const w = document.querySelector('#product-grid .grid__item').offsetWidth;
      
      filter.setAttribute('open','');
      product_grid_w.setAttribute('filters-open','');

      filter.style.width = `${w}px`;

      product_grid_w.style.width = `${product_grid_w.offsetWidth - w - 30}px`;
      product_grid_w.style.marginLeft = 'auto';
      product_grid_w.style.marginRight = '0';
      if (loadMore) {
        loadMore.style.width = `${loadMore.offsetWidth - w - 30}px`;
        loadMore.style.marginLeft = 'auto';
        loadMore.style.marginRight = '0';
      }
    } else { 
      /*filter.removeAttribute('open');
      product_grid_w.removeAttribute('filters-open');*/
   /* }

	filter.querySelector('.desktop-filters-btn')
		.addEventListener('click', () => {
			const product_grid = document.querySelector('#product-grid');
			const w = document.querySelector('#product-grid .grid__item').offsetWidth;

			filter.toggleAttribute('open');
			product_grid.toggleAttribute('filters-open');

			if(product_grid.hasAttribute('filters-open') && window.innerWidth >= 750) {

				product_grid.style.width = `${product_grid.offsetWidth - w - 30}px`;
				product_grid.style.marginLeft = 'auto';
				product_grid.style.marginRight = '0';
                if (loadMore) {
                  loadMore.style.width = `${loadMore.offsetWidth - w - 30}px`;
                  loadMore.style.marginLeft = 'auto';
                  loadMore.style.marginRight = '0';
                }

				filter.style.width = `${w}px`;
			} else {
				product_grid.style.width = 'auto'; 
				product_grid.style.marginLeft = 'auto';
				product_grid.style.marginRight = 'auto';
                if (loadMore) {
                  loadMore.style.width = `auto`;
                  loadMore.style.marginLeft = 'auto';
                  loadMore.style.marginRight = 'auto';
                  
                }

				filter.style.width = 'auto';
			}
		});*/
});